//
//
//
//

import { mapActions } from 'vuex';

export default {

  async mounted() {
    this.setGeneralLoader(true);
    if (this.$utils.getAppType() !== 'p2pay') {
      await Promise.allSettled([
        this.loadSettingsLimits(),
        this.loadTradingOptions(),
        this.loadSettingsIndividual(),
      ]);
    }
    await Promise.allSettled([
      this.loadSettingsVerification(),
      this.loadSettingsUploadOptions(),
      this.loadSettingsSystemNotifications(),
      this.loadWatermarkSettings(),
      this.loadSettingsTechnicalWork(),
    ]);
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('settingsNotifications', {
      loadSettingsNotifications: 'loadData',
    }),
    ...mapActions('settingsEmail', {
      loadSettingsEmail: 'loadData',
    }),
    ...mapActions('settingsLimits', {
      loadSettingsLimits: 'loadData',
      loadTradingOptions: 'loadTradingOptions',
    }),
    ...mapActions('settingsTechnicalWork', {
      loadSettingsTechnicalWork: 'loadData',
    }),
    ...mapActions('settingsVerification', {
      loadSettingsVerification: 'loadData',
    }),
    ...mapActions('settingsUploadOptions', {
      loadSettingsUploadOptions: 'loadData',
    }),
    ...mapActions('settingsIndividual', {
      loadSettingsIndividual: 'loadData',
    }),
    ...mapActions('settingsWatermark', {
      loadWatermarkSettings: 'loadData',
    }),
    ...mapActions('settingsSystemNotifications', {
      loadSettingsSystemNotifications: 'loadData',
    }),
  },
};
